/**
 * Returns a safe return URL for post-login redirects.
 * Allows:
 * - Same-origin absolute URLs
 * - Relative paths beginning with a single "/" (not protocol-relative)
 */
export const getSafeReturnUrl = (rawUrl) => {
	if (!rawUrl || typeof rawUrl !== 'string') {
		return null;
	}

	const trimmed = rawUrl.trim();
	if (!trimmed) {
		return null;
	}

	// Allow relative app paths like "/home/project/ABC"
	if (trimmed.startsWith('/') && !trimmed.startsWith('//')) {
		return trimmed;
	}

	// Allow only same-origin absolute URLs
	try {
		const parsed = new URL(trimmed, window.location.origin);
		if (parsed.origin !== window.location.origin) {
			return null;
		}
		return parsed.pathname + parsed.search + parsed.hash;
	} catch (error) {
		return null;
	}
};
